export default "__VITE_ASSET__Ti5xBLkh__"